/**
 * ApiUsageMetrics Component
 * Grid of API usage metric cards for the Gateway Dashboard
 */

import { useSnapshot } from "valtio";
import { financialStore, formatCurrency } from "../stores/financial";
import MetricCard from "@/components/MetricCard";
import { Skeleton } from "@/components/ui/skeleton";
import { Activity, CreditCard, Key, Zap } from "lucide-react";

/**
 * Format a number with commas (e.g., 12543 -> "12,543")
 */
function formatNumber(num: number): string {
  return new Intl.NumberFormat("en-US").format(num);
}

export default function ApiUsageMetrics() {
  const { costBreakdown, loading } = useSnapshot(financialStore);

  if (loading && !costBreakdown) {
    return (
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {[1, 2, 3, 4].map((i) => (
          <Skeleton key={i} className="h-[120px]" />
        ))}
      </div>
    );
  }

  const totalRequests = costBreakdown?.totalRequests ?? 0;
  const totalCost = costBreakdown?.totalCost ?? 0;

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <MetricCard
        title="API Requests"
        value={formatNumber(totalRequests)}
        subtitle="Last 30 days"
        icon={<Activity className="h-4 w-4" />}
      />
      <MetricCard
        title="Total Cost"
        value={formatCurrency(totalCost)}
        subtitle="This month"
        icon={<CreditCard className="h-4 w-4" />}
      />
      <MetricCard
        title="API Keys"
        value="—"
        subtitle="Not implemented"
        icon={<Key className="h-4 w-4" />}
      />
      <MetricCard
        title="Avg Latency"
        value="—"
        subtitle="Not tracked"
        icon={<Zap className="h-4 w-4" />}
      />
    </div>
  );
}
